import { getLogger } from "@expert/logging";
import ky from "ky";

import { createAuthorizationBearerHook, createErrorLoggingHook, userCache } from "@/shared-utils/auth";

import { env } from "./environment";

export const getTrainingSessionApiClient = () => {
    return ky.create({
        prefix: env.trainingSessionBaseUrl,
        timeout: 30_000,
        retry: { limit: 2, methods: ["POST"], retryOnTimeout: true, jitter: true },
        hooks: {
            beforeRequest: [createAuthorizationBearerHook(() => userCache.ssoAccessToken)],
            beforeError: [createErrorLoggingHook(getLogger({ module: "api" }))],
        },
    });
};
